import { FC, ChangeEvent, useState } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { ReactComponent as TrashIcon } from 'src/assets/trash.svg';
import { AddLeadingZero } from 'src/utils/utils';
import { Typography } from "@material-ui/core";
import { EMPTY_OUTGOING_MESSAGE_PLACEHOLDER } from "src/config/constants"

interface ErrorMessageProps {
  errorMessage: ErrorMessage;
  tagColoredElementStyle: any;
  order: number;
  onRemoveErrorMessage: (id: string) => void;
  onChangeErrorMessage: (id: string, newErrorMessage: string) => void;
};

const ErrorMessage: FC<ErrorMessageProps> = ({ errorMessage, order, tagColoredElementStyle, onRemoveErrorMessage, onChangeErrorMessage }: ErrorMessageProps) => {
  const classes = useStyles();
  const [newErrorMessage, setNewErrorMessage] = useState<string>(errorMessage.message || "")

  const handlerOnChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setNewErrorMessage(event.target.value)
    onChangeErrorMessage(errorMessage.id, event.target.value)
  }

  const handlerOnRemove = () => {
    onRemoveErrorMessage(errorMessage.id)
  }

  return (
    <div className={classes.root}>
      <span style={tagColoredElementStyle} />
      <Typography className={classes.optionOrder}>
        Mensaje {AddLeadingZero(order)}
      </Typography>
      <label htmlFor={errorMessage.id} className={classes.label} tabIndex={0}>
        <textarea
          rows={4}
          cols={50}
          id={errorMessage.id}
          className={classes.input}
          placeholder={newErrorMessage || EMPTY_OUTGOING_MESSAGE_PLACEHOLDER}
          value={newErrorMessage}
          onChange={handlerOnChange}
          required>
          </textarea>
        <button className={classes.iconButton}>
          <TrashIcon onClick={handlerOnRemove} />
        </button>
      </label>
    </div>
  );
};

ErrorMessage.defaultProps = { };

export default ErrorMessage;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: "30px 0 0 0",
    display: "grid",
    width: "582px",
    gridTemplateColumns: "0.5fr 10fr 20fr",
    alignItems: "start",
    marginBottom: "9px",
    background: "#FFFFFF",
    border: "1px solid #EFF2F8",
    borderRadius: "8px",
    padding: "24px",

    "&:hover": {
      boxShadow: "0px 2px 24px rgba(0, 0, 0, 0.08)",
    }
  },
  optionOrder: {
    margin: "10px 8px 0 24px",
    fontSize: "14px",
    fontWeight: 600,
  },
  label: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "start",

    "&:focus-within > button": {
      visibility: "visible",
    },
  },
  input: {
    resize: "none",
    width: "90%",
    background: "#dd99",
    padding: "9px 5px 9px 10px",
    borderRadius: "2.5px",
    border: "none",
    backgroundColor: "#ffffff",
    fontSize: "14px",
    fontWeight: 600,
    fontFamily: "Poppins",

    "&:focus": {
      outline: "none",
      border: "solid 1px #cdd5e0",
    },
  },
  iconButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    visibility: "hidden",
    margin: "10px 0 0 5px",
  },
}));

